import { render, staticRenderFns } from "./ItemsSpent.vue?vue&type=template&id=60a849af&"
import script from "./ItemsSpent.vue?vue&type=script&lang=js&"
export * from "./ItemsSpent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports